import * as React from "react";
import Spinner from "../../components/Spinner";
import { Redirect } from "react-router-dom";
import GoogleMapReact from "google-map-react";
import { STORAGE } from "../../firebase";

import ArticleEditor from "./ArtickeEditor";
import { ScaleUploadImg } from "../../components/ScaleUploadImg";
import { EXCLUDED_IDS_FROM_MENU } from "../../utils/config";

class ManageArticleDetailScreen extends React.Component {
  constructor(props) {
    super(props);
    let { article } = this.props.location;
    if (article && !article.articleImages) {
      article = { ...article, articleImages: [] };
    }
    if (article && !article.galleryImages) {
      article = { ...article, galleryImages: [] };
    }
    this.state = article;
  }

  componentWillReceiveProps(nextProps) {
    const { message } = nextProps.app;
    if (message.length > 0 && message !== "{ok}")
      setTimeout(() => {
        this.props.appMessage("");
      }, 6000);
    else if (message === "{ok}") {
      this.props.appMessage("");
      this.props.history.goBack();
    }
  }

  handleMapClick = (e) => {
    this.setState({
      center: {
        lat: e.lat,
        lng: e.lng,
      },
    });
  };

  renderMap = () => {
    const AnyReactComponent = () => (
      <div
        style={{
          width: "10px",
          height: "10px",
          backgroundColor: "red",
          borderRadius: "50%",
        }}
      ></div>
    );

    let { lat, lng } = this.state.center;
    lat = parseFloat(lat);
    lng = parseFloat(lng);
    let centerMap = { lat, lng };

    return (
      <div className="mt-2" style={{ height: "30vh", width: "100%" }}>
        <GoogleMapReact
          onClick={this.handleMapClick}
          bootstrapURLKeys={{ key: "AIzaSyCZRcoMluYNAv9XP2dtItF2TC4Q7PtEhpM" }}
          defaultCenter={centerMap}
          defaultZoom={16}
        >
          <AnyReactComponent lat={lat} lng={lng} />
        </GoogleMapReact>
      </div>
    );
  };

  renderInput = ({ fieldName, value, label, secure = false }) => {
    return (
      <div>
        <label htmlFor="exampleInputEmail1">{label}</label>
        <input
          type={secure ? "password" : "text"}
          className="form-control"
          placeholder={label}
          onChange={(event) =>
            this.setState({ [fieldName]: event.target.value })
          }
          defaultValue={value}
        />
      </div>
    );
  };

  renderTextarea = ({ value, label }) => (
    <div className="mt-2">
      <label htmlFor="exampleInputEmail1">{label}</label>
      <ArticleEditor
        onChange={(description) => this.setState({ description })}
        defaultValue={value || ""}
      />
    </div>
  );

  parentIdChange = (e) => {
    const parentId = e.target.value !== "0" ? e.target.value : null;
    this.setState({ parentId });
  };
  renderParentSelector = () => {
    const { articleList } = this.props.articles;
    const { parentId } = this.state;
    // check if this article is a parent for another
    const isParent = articleList.find(
      (article) => article.parentId && article.parentId === this.state.id
    );
    if (isParent !== undefined)
      return (
        <div className="alert alert-info small mb-3 mt-2">
          Ten artykuł jest już rodzicem innego artykułu, nie można więc mu
          przypisać rodzica
        </div>
      );

    return (
      <div className="input-group mb-3 mt-2">
        <select
          className="custom-select"
          onChange={this.parentIdChange}
          defaultValue={parentId ? parentId : null}
        >
          <option value={0}>Artykuł rodzic w menu</option>
          {articleList
            .filter((article) => article.id !== this.state.id)
            .filter((article) => !article.parentId)
            .map((article) => (
              <option value={article.id} key={article.id}>
                {article.title}
              </option>
            ))}
        </select>
      </div>
    );
  };

  removeSelectedImage = (articleImage, e) => {
    e.preventDefault();
    const articleImages = this.state.articleImages.filter(
      (img) => img !== articleImage
    );
    this.setState({
      articleImages,
    });
  };

  renderArticleImageForm = (articleImg, index) => (
    <div className="border-top mt-2" key={index}>
      <img alt="grafika nagłówka" className="img-fluid" src={articleImg} />
      <div className="text-right">
        <button
          className="btn btn-sm btn-danger"
          onClick={(e) => this.removeSelectedImage(articleImg, e)}
        >
          Usuń grafikę
        </button>
      </div>
    </div>
  );

  renderImages = (articleImages) => (
    <div className="mt-2">
      <label htmlFor="exampleInputEmail1">
        Grafiki w nagłówku{" "}
        <small>
          grafiki są automatycznie pominejszone do wymiarów 500x1200px)
        </small>
      </label>
      {articleImages && articleImages.map(this.renderArticleImageForm)}

      <div>Dodaj kolejne grafiki</div>
      <ScaleUploadImg
        maxHeight={500}
        maxWidth={1200}
        onChangePhoto={(newImage) => {
          this.setState({
            articleImages: [...this.state.articleImages, newImage],
          });
        }}
      />
    </div>
  );

  removeSelectedGalleryImage = (galleryImage, e) => {
    e.preventDefault();
    const galleryImages = this.state.galleryImages.filter(
      (img) => img !== galleryImage
    );
    this.setState({
      galleryImages,
    });
  };

  renderGalleryImageForm = (galleryImg, index) => (
    <div className="col-md-6 mt-2" key={index}>
      <div className="p-2 border">
        <img alt="grafika galerii" className="img-fluid" src={galleryImg} />
        <div className="text-right">
          <button
            className="btn btn-sm btn-danger"
            onClick={(e) => this.removeSelectedGalleryImage(galleryImg, e)}
          >
            Usuń grafikę
          </button>
        </div>
      </div>
    </div>
  );

  renderGallery = (galleryImages) => (
    <div className="mt-2 pt-2 border-top">
      <label htmlFor="exampleInputEmail1">
        Zdjęcia galerii{" "}
        <small>
          grafiki są automatycznie pominejszone do wymiarów max 1200x1200px)
        </small>
      </label>
      <div className="row">
        {galleryImages && galleryImages.map(this.renderGalleryImageForm)}
      </div>
      <div>Dodaj kolejne grafiki</div>
      <ScaleUploadImg
        maxHeight={1200}
        maxWidth={1200}
        onChangePhoto={(newImage) => {
          this.setState({
            galleryImages: [...this.state.galleryImages, newImage],
          });
        }}
      />
    </div>
  );

  makeid = (length) => {
    var result = [];
    var characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result.push(
        characters.charAt(Math.floor(Math.random() * charactersLength))
      );
    }
    return result.join("");
  };

  getImgExtension = (image) => {
    const signatures = {
      JVBERi0: "pdf",
      R0lGODdh: "gif",
      R0lGODlh: "gif",
      iVBORw0KGgo: "png",
      "/9j/4AAQSkZJRgABAQ": "jpeg",
    };
    for (var s in signatures) {
      if (image.indexOf(s) === 0) {
        return signatures[s];
      }
    }
  };

  base64Regex = (str) => {
    // opts = Object.assign({}, opts);
    // const regex = '(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)';
    // const regex2 = /^data:image\/(?:gif|png|jpeg|bmp|webp|svg\+xml)(?:;charset=utf-8)?;base64,(?:[A-Za-z0-9]|[+/])+={0,2}/;
    // return new RegExp(regex2, 'g');
    // //return opts.exact ? new RegExp(`(?:^${regex}$)`) : new RegExp(regex, 'g');

    const regex = /src="(data:image\/[^;]+;base64[^"]+)"/g;
    const m = str.match(regex);

    if (m === null) return [];

    // This is necessary to avoid infinite loops with zero-width matches
    if (m.index === regex.lastIndex) {
      regex.lastIndex++;
    }
    let result = [];
    m.map((image) => {
      image = image.split("base64,");
      image = image[1];
      result.push(image);
    });
    return result;
  };

  handleDescriptionImages = (description) =>
    new Promise(async (resolve) => {
      let base64Images = this.base64Regex(description);
      if (!base64Images || !base64Images.length) return resolve(description);

      base64Images = base64Images
        .filter((img) => img !== "src=")
        .filter((img) => img.length > 50);

      if (!base64Images || !base64Images.length) return resolve(description);

      const handleImg = async (image) => {
        const mimeType = this.getImgExtension(image);
        const newFileId = this.makeid(12);
        const newFileName = `${newFileId}.${mimeType}`;

        if (image.indexOf("base64,") !== -1) {
          image = image.split("base64,");
          image = image[1];
        }
        if (image[image.length - 1] === '"') {
          image = image.slice(0, -1);
        }

        const storageChild = STORAGE.child(newFileName);
        storageChild.child(`images/${newFileName}`);
        await storageChild.putString(image, "base64");
        const imageSrc = await storageChild.getDownloadURL();
        description = description.replace(
          `data:image/${mimeType};base64,${image}`,
          imageSrc
        );
      };
      const imagePromises = base64Images.map(handleImg);
      await Promise.all(imagePromises);

      return resolve(description);
    });

  editArticle = async (e) => {
    e.preventDefault();
    this.props.appLoading(true);
    const { description } = this.state;
    const updatedDescription = await this.handleDescriptionImages(description);

    await this.props.updateArticleData({
      ...this.state,
      description: updatedDescription,
    });
  };

  isDisabled() {
    const { description, title } = this.state;

    if (!description || !description.length || !title || !title.length)
      return true;
    else return false;
  }

  removeArticle = async () => {
    await this.props.deleteArticle(this.state.id);
    this.props.history.push("/manageapp/manage-article");
  };

  render() {
    if (!this.state) return <Redirect to="/manageapp" />;
    const { title, description, articleImages, galleryImages } = this.state;
    if (this.props.app.loading) return <Spinner />;

    const nonStandardArticle =
      EXCLUDED_IDS_FROM_MENU.indexOf(this.state.id) !== -1;

    return (
      <div>
        {this.props.app.message.length > 0 ? (
          <div className="alert alert-danger">{this.props.app.message}</div>
        ) : null}

        <form>
          {this.renderInput({
            fieldName: "title",
            value: title,
            label: "Tytuł",
          })}
          {this.renderTextarea({
            value: description,
            label: "Treść",
          })}
          {!nonStandardArticle && this.renderParentSelector()}
          {this.renderImages(articleImages)}
          {this.renderGallery(galleryImages)}
          {this.state.center ? this.renderMap() : null}
          <button
            type="submit"
            className="btn btn-primary mt-3"
            disabled={this.isDisabled()}
            onClick={this.editArticle}
          >
            Aktualizuj
          </button>
        </form>

        <div className="mt-5">
          <button
            onClick={this.removeArticle}
            className="btn btn-danger btn-sm"
          >
            Usuń artykuł <small>(UWAGA: tej czynności nie można cofnąć</small>
          </button>
        </div>
      </div>
    );
  }
}

export default ManageArticleDetailScreen;



// WEBPACK FOOTER //
// ./src/screens/ManageArticle/ManageArticleDetailScreen.js